export const adData = {
  pagePath: '',
  targeting: {}
};

export const trackingData = {
  pageError: 0,
  siteType: 'react web',
  siteRsid: 'cbsimaxprepssite',
  content: '', // reset on every new 'trackData'
  searchTerm: '', // reset on every new 'trackData'
  searchDimension: '', // reset on every new 'trackData'
  isReact: 1
};
